import { ScheduleFormValues } from './types';
import {
  makeMarketingContentCreateOperation,
  makeMarketingContentUpdateOperation,
} from '../operations/marketingContent';
import { Operation } from '../types';

export const getMarketingContentOperations = (
  values: ScheduleFormValues,
  offerId: string,
): Operation => {
  const triggeredMessageContent = {
    fulfillmentSms: values.marketingContent?.triggeredMessageContent?.fulfillmentSms || null,
    visibilitySms: values.marketingContent?.triggeredMessageContent?.visibilitySms || null,
    progressSms: values.marketingContent?.triggeredMessageContent?.progressSms || null,
  };

  if (!values.marketingContent?.id) {
    return makeMarketingContentCreateOperation({
      offerId,
      triggeredMessageContent,
    });
  }

  return makeMarketingContentUpdateOperation({
    id: values.marketingContent?.id,
    triggeredMessageContent,
  });
};
